import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 12,
  },
  palette: {
    primary: {
      main: "#577EC6",
      800: "#37B8D9",
    },
    secondary: {
      main: "#7AE4FF", //#7AE4FF
    },
    text: {
      primary: "#4e4e4e",
    },
    // mode: "dark",
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: "pointer",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: "0px !important",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: "48px !important",
          paddingLeft: "0px !important",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          boxShadow: "none",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-4px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "14px !important",
        },
        input: {
          padding: "12px 14px !important",
          // minWidth:"240px",
        },
        inputMultiline: {
          padding: "12px !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "24px !important",
          textTransform: "capitalize",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          marginBottom: "24px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          padding: "6px 12px",
          border: "1px solid #dcdce1",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-of-type(even)": {
            backgroundColor: "#efefef",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          zIndex: "99",
          position: "relative",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "4px 16px",
          left: "auto !important",
        },
        footer: {
          border: "none",
        },
        head: {
          padding: "4px 16px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: "0px !important",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          boxShadow: "none",  
          border: "1px solid #D7DFEE",
        },
      },
    },
  },
});

export default theme;
